import { colors } from "colors"
import { StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  container: {
    alignItems: "center",
    backgroundColor: colors.buttonBackground,
    borderRadius: 12,
    padding: 4,
    paddingVertical: 12,
    width: "100%",
    marginBottom: 10,
  },
  title: {
    fontFamily: typography.primary.normal,
    fontWeight: "bold",
  },
})
